import {
  DocumentData,
  DocumentReference,
  QueryDocumentSnapshot,
  addDoc,
  collection,
  deleteDoc,
  deleteField,
  doc,
  getDocs,
  getFirestore,
  query,
  updateDoc,
  where,
} from "firebase/firestore";

import { app, auth } from "./firebase";
import { getDatabase, ref, set } from "firebase/database";
import { AddUserProfileType } from "../Types/userProfile";
import { AddProjectExperimentType } from "../Types/projectExperiment";
import { NewGroupProfileType } from "../Types/groupProfile";
import { NewProjectProfileType } from "../Types/projectProfile";
import { AddSurveyType } from "../Types/surveys";

const db = getFirestore(app);

export const firestore = getFirestore(app);

// All user profiles
export const userProfilesCollection = collection(firestore, "userProfiles");

// All group documents
export const groupProfilesCollection = collection(firestore, "Groups");

//Update existing project with its ID
export const UpdateGroupID = async (arg1: string, arg2: DocumentReference) => {
  console.log("on entry to UpdateID and ref = ", arg1);
  //let tempRef = arg1;
  //let docRef = doc(db, "projectProfiles", tempRef);

  console.log("doc id = ", arg1);
  console.log("doc ref = ", arg2);
  updateDoc(arg2, {
    groupID: arg1,
  });
};

export const deleteGroup = async (docID: string) => {
  const res = await deleteDoc(doc(db, "Groups", docID));
};

// All project documents

export const deleteProject = async (docID: string) => {
  const res = await deleteDoc(doc(db, "projectProfiles", docID));
};

export const projectCollection = collection(firestore, "projectProfiles");

// Add new project
export const addProject = async (newProject: NewProjectProfileType) => {
  const newProjectProfile = await addDoc(projectCollection, {
    ...newProject,
  });
  console.log("in addProject");
  console.log("newProject = ", newProjectProfile);
  console.log("newProject id = ", newProjectProfile.id);
  return newProjectProfile.id;
};

export const UpdateOldExperimentFormats = (arg1: string) => {
  const docRef = doc(db, "projectExperiments", arg1);

  console.log(" else and projectExperiment.id = ", arg1);
  const data = {
    copyButton: deleteField(),
    dataDescription0: deleteField(),
    dataDescription1: deleteField(),
    dataDescription2: deleteField(),
    dataDescription3: deleteField(),
    dataShare0: deleteField(),
    dataShare1: deleteField(),
    dataShare2: deleteField(),
    dataShare3: deleteField(),
    dataURL0: deleteField(),
    dataURL1: deleteField(),
    dataURL2: deleteField(),
    dataURL3: deleteField(),
    deleteButton: deleteField(),
    messages: deleteField(),
    pasteButton: deleteField(),
    pdfButton: deleteField(),
    pdfFileLink: deleteField(),
    selectButton: deleteField(),
    select: deleteField(),
  };
  console.log("data = ", data);
  updateDoc(docRef, data)
    .then(() => {
      console.log("fields successfully deleted");
    })
    .catch(() => {
      console.log("error on update");
    });
  updateDoc(docRef, {
    projectData: [],
  });
};

//Update existing project with its ID
export const UpdateProjectID = async (
  arg1: string,
  arg2: DocumentReference
) => {
  console.log("on entry to UpdateID and id = ", arg1);
  console.log("on entry to UpdateID and ref = ", arg2);
  //let tempRef = arg1;
  //let docRef = doc(db, "projectProfiles", tempRef);

  updateDoc(arg2, {
    projectID: arg1,
  });
};

// Add new user profile
export const addUserProfile = async (userProfileData: AddUserProfileType) => {
  const newUserProfile = await addDoc(userProfilesCollection, {
    ...userProfileData,
  });
  console.log("in addUserProfile");
  console.log("user data = ", userProfileData);
  console.log(`New user profile was created at ${newUserProfile.path}`);
  console.log(`New user profile id is ${newUserProfile.id}`);
};

// All user groups
export const groupCollection = collection(firestore, "Groups");

// Add new user group
export const addUserGroup = async (newGroup: NewGroupProfileType) => {
  const newLabGroup = await addDoc(groupCollection, {
    ...newGroup,
  });
  console.log("in addUserGroup");
  console.log("newLabGroup = ", newLabGroup);
  //console.log(`New lab group path = ${newGroup.path}`);
  //console.log(`New lab group id = ${newGroup.id}`);
};

// All user projects
export const projectExperimentsCollection = collection(
  firestore,
  "projectExperiments"
);

// All user surveys
export const SurveysCollection = collection(firestore, "Surveys");

// Add new user experiment
export const addUserExperiment = async (
  projectExperimentData: AddProjectExperimentType
) => {
  const newProjectExperiment = await addDoc(projectExperimentsCollection, {
    ...projectExperimentData,
  });
  console.log("in addProjectExperiment");
  console.log("experiment data = ", projectExperimentData);
  //console.log(`New user project was created at ${newProject.path}`);
  //console.log(`New user project id is ${newProject.id}`);
  return newProjectExperiment;
};

// Add new user experiment
export const addSurvey = async (SurveyData: AddSurveyType) => {
  const newSurvey = await addDoc(SurveysCollection, {
    ...SurveyData,
  });

  //console.log(`New user project was created at ${newProject.path}`);
  //console.log(`New user project id is ${newProject.id}`);
  return newSurvey;
};

// Get user profile data

export async function GetDocID() {
  var doc: QueryDocumentSnapshot<DocumentData, DocumentData>;
  var currentUserID = "";
  var currentUser = "";
  var profile: DocumentData;
  const db = getFirestore(app);
  console.log("in controller for getDocID #1");
  auth.onAuthStateChanged(async (user) => {
    const userValue = await Promise.resolve(user);
    //Promise.reject(console.log("err"));
    console.log("in controller for getDocID #2");
    if (userValue) {
      const currentUser = userValue;
      const currentUserID = user?.uid;
      console.log("in controller for getDocID #3");
      console.log(
        "in controller for getDocID Currently logged in user =",
        currentUser
      );
      console.log(
        "in controller for getDocID Currently logged in user id =",
        currentUserID
      );
      const q = query(
        collection(db, "userProfiles"),
        where("userUID", "==", currentUserID)
      );
      console.log("in controller for getDocID #4");
      const querySnapshot = await getDocs(q);

      console.log("in controller for getDocID #5");

      //if (!querySnapshot) return <div>Loading...</div>;
      for (doc of querySnapshot.docs) {
        console.log("in controller for getDocID #6");

        const profile = doc.data();

        console.log("in controller for getDocID and the following is the doc");
        console.log(doc.id, " => ", doc.data());
        console.log(
          "in controller for getDocID userProfileName = " +
            doc.data().userProfileName
        );
        console.log(
          "in controller for getDocID using profile and user email = " +
            profile.userEmail
        );
        console.log(
          "in controller for getDocID using photo = " + profile.userPhotoName
        );
        localStorage.setItem("photoURL", profile.userPhotoName);
        console.log(
          "in controller for getDocID after q and user id = " + currentUserID
        );
        console.log(
          "in controller for getDocID before return and doc.data() = " +
            doc.data()
        );
        //return doc.data();
        //return profile.userPhotoName;
      }
    }
  });
}

export function saveUserProfileChanges(
  userAILink1: string,
  userAILink2: string,
  userAILink3: string,
  userAILink4: string,
  docID: string,
  userAbout: string,
  userConnections: Array<string>,
  userEmail: string,
  userFirstName: string,
  userLastName: string,
  userPhotoName: string,
  userProfileName: string,
  userProfileLink1: string,
  userProfileLink2: string,
  userProfileLink3: string,
  userProfileLink4: string,
  userUID: string
) {
  const db = getDatabase();
  set(ref(db, "userProfiles/" + docID), {
    userAILink1: userAILink1,
    userAILink2: userAILink2,
    userAILink3: userAILink3,
    userAILink4: userAILink4,
    userAbout: userAbout,
    userConnections: userConnections,
    userEmail: userEmail,
    userFirstName: userFirstName,
    userLastName: userLastName,
    userPhotoName: userPhotoName,
    userProfileName: userProfileName,
    userProfileLink1: userProfileLink1,
    userProfileLink2: userProfileLink2,
    userProfileLink3: userProfileLink3,
    userProfileLink4: userProfileLink4,
    userUID: userUID,
  });
}
